import './InputBoilerplate.css';

function InputBoilerplate({label, type, inputName, placeholder, setState}) {
  return (
    <div className="input_group">
        <label className="input_field_label">{label}</label>
        <input
            className='input_field'
            type={type}
            value={inputName}
            placeholder={placeholder}
            onChange={e => setState(e.target.value)}
        />
    </div>
  )
}

export default InputBoilerplate